import HttpService from 'services/HttpService';

export default class WatchlistService {
    constructor() {
        this._http = new HttpService();
        this.userWatchlistIds = {};
        this.loaded = false;
        this.initWatchlist();
    }

    initWatchlist() {
        // No watchlist for anon users
        if (!CBS.Registry.user.sub_status) return;

        const url = `/user-profile/xhr/watchlist-ids/?nocache=${new Date().getTime()}`;

        this._http
            .doGet(url)
            .then(({ data }) => {
                if (Array.isArray(data?.watchlist)) {
                    this.userWatchlistIds = Object.fromEntries(
                        data?.watchlist?.map((value) => [value, true]),
                    );
                    this.loaded = true;
                }
            })
            .catch((e) => {
                console.error('Error fetching watchlist IDs:', e.message);
            });
    }

    isContentInWatchlist(id) {
        if (Object.keys(this.userWatchlistIds).length === 0) return false;
        return id in this.userWatchlistIds;
    }

    addContentToWatchlist(id, addUrl) {
        return this._http.doGet(addUrl).then((res) => {
            if (res.data.success) {
                this.userWatchlistIds[id] = true;
            }

            return res;
        });
    }

    removeContentFromWatchlist(id, removeUrl) {
        return this._http.doGet(removeUrl).then((res) => {
            if (res.data.success) {
                if (id in this.userWatchlistIds) {
                    delete this.userWatchlistIds[id];
                }
            }

            return res;
        });
    }
}
